<template>
  <v-row>
    <v-col cols="12" md="6">
      <a id="subscriptions" />
      <h2 class="text-h5 text-center mb-3">Unlimited subscriptions</h2>
      <pricing-subscriptions @purchase="$router.push({ name: 'account' })" />
    </v-col>
    <v-col cols="12" md="6">
      <a id="bulk-packs" />
      <h2 class="text-h5 text-center mb-3">Bulk packs</h2>
      <pricing-bulk-packs @purchase="$router.push({ name: 'account' })" />
    </v-col>
    <v-col cols="12" md="10" offset-md="1">
      <div class="mt-6 text-h6 text-center">We also offer additional tools, features, and discounts for <router-link :to="{ name: 'business' }">businesses / organizations</router-link></div>
    </v-col>
  </v-row>
</template>

<script>
import PricingBulkPacks from '@/components/PricingBulkPacks.vue';
import PricingSubscriptions from '@/components/PricingSubscriptions.vue';

export default {
  name: 'start-pricing',

  components: {
    PricingBulkPacks,
    PricingSubscriptions
  }
}
</script>
